import { Divider, Flex } from 'antd';
import styles from './personal-info.module.scss';

type PersonalInfoProps = {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
};

export function PersonalInfo({ first_name, last_name, email, phone }: PersonalInfoProps) {
  return (
    <Flex vertical>
      <Flex vertical gap={5}>
        <p className={styles.personalInfoTitle}>Name</p>
        <p>{`${first_name} ${last_name}`}</p>
      </Flex>

      <div className={styles.personalInfoDivider}>
        <Divider dashed />
      </div>

      <Flex vertical gap={5}>
        <p className={styles.personalInfoTitle}>Email address</p>
        <p>{email}</p>
      </Flex>

      <div className={styles.personalInfoDivider}>
        <Divider dashed />
      </div>

      <Flex vertical gap={5}>
        <p className={styles.personalInfoTitle}>Phone number</p>
        <p>{phone}</p>
      </Flex>
    </Flex>
  );
}
